import { array, boolean, nullable, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

//import { FilterRequestColumn } from './FilterRequestColumn';
import { Id as ClientId } from '../../client/Id';
import { Id as JobTypeId } from '../../job/job-type';
import { Id as RequestTypeId } from '../../job/request-type';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';
import { DifficultyWithUnknown } from '../DifficultyWithUnknown';
import { UserId } from '../UserId';

import { AssigneeType } from './AssigneeType';
import { ViewType } from './ViewType';

export const FilterRequest = struct({
	client: array(ClientId),
	jobType: array(JobTypeId),
	requestType: array(RequestTypeId),
	requirements: array(array(RequirementId)),
	createdAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
	assignee: array(UserId),
	assigneeType: array(AssigneeType),
	difficulty: array(DifficultyWithUnknown),
	viewType: nullable(ViewType),
	showCompleted: boolean,
});
